import styled, { css } from 'styled-components';

export const TagPro = styled.span`
  ${({ theme, position, size }) => {
    const sizes = {
      small: {
        fontSize: theme.v2.font.sizes.xxs,
        padding: '5px 8px',
      },
      medium: {
        fontSize: theme.v2.font.sizes.sm2,
        padding: '6px 9px',
      },
    };

    return (css`
    align-items: center;
    background: ${theme.v2.colors.gradient.secondary};
    border-radius: 100px;
    bottom: ${position && position.bottom ? position.bottom : 'auto'};
    color: ${theme.v2.colors.brand.primaryUltraLight};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${sizes[size].fontSize};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 5px;
    justify-content: center;
    left: ${position && position.left ? position.left : 'auto'};
    max-width: fit-content;
    padding: ${sizes[size].padding};
    position: ${position ? 'absolute' : 'relative'};
    right: ${position && position.right ? position.right : 'auto'};
    top: ${position && position.top ? position.top : 'auto'};
  `);
  }};
`;
